import TutorModel from "./TutorModel";
import UserModel from "./UserModel";

export default class SupervisorModel extends UserModel {
  full_name?: string;
  city?: string | null;
  native_language?: string | null;
  supervisor?: TutorModel[] | null;
  constructor(arg: any) {
    super(arg);
    this.full_name = arg.full_name;
    this.city = arg.city;
    this.native_language = arg.native_language;
    if (!!arg.supervisor)
      this.supervisor = TutorModel.fromApiResponse(arg.supervisor);
  }
}
